const BookingPageFields = [
  {
    id: Math.random() * 10,
    name: "Booking_Page_Input",
    fields: [
      {
        id: Math.random() * 10,
        name: "GPS_Link",
        label: "GPS Tracking Link",
        type: "text",
      },

      {
        id: Math.random() * 10,
        name: "Sim_Tracking_Link",
        label: "SIM Tracking Link",
        type: "text",
      },
    ],
  },
];

export { BookingPageFields };
